.panel {
  background-color: var(--background-default);
}
